import React from 'react';
import {Tab} from 'components';
import {ProviderHeader} from 'components/Headers/ProviderHeader';
import {PaymentSettings} from 'features/Provider/Payments/PaymentSettings';
import {useTabs} from 'hooks';

import DPSessions from '../components/DPSessions';
import Receipts from '../components/Receipts';
const {useTranslation} = require('react-i18next');

enum RevenueDigitalPracticeTabs {
  settings = 'settings',
  sessions = 'sessions',
  receipts = 'receipts',
}

export default function DPSetting() {
  const {t} = useTranslation();
  const {tab, onTabClick} = useTabs<RevenueDigitalPracticeTabs>(
    RevenueDigitalPracticeTabs.settings,
  );

  return (
    <>
      <ProviderHeader
        title={t('payroll.digitalPractice')}
        showBookButtonInMobile={true}
      />
      <nav className="-mb-px flex">
        <Tab
          onClick={() => {
            onTabClick(RevenueDigitalPracticeTabs.settings);
          }}
          width="1/3"
          current={tab === RevenueDigitalPracticeTabs.settings}
        >
          {t('payroll.settings')}
        </Tab>
        <Tab
          onClick={() => {
            onTabClick(RevenueDigitalPracticeTabs.sessions);
          }}
          width="1/3"
          current={tab === RevenueDigitalPracticeTabs.sessions}
        >
          {t('payroll.sessions')}
        </Tab>
        <Tab
          onClick={() => {
            onTabClick(RevenueDigitalPracticeTabs.receipts);
          }}
          width="1/3"
          current={tab === RevenueDigitalPracticeTabs.receipts}
        >
          {t('payroll.receipts')}
        </Tab>
      </nav>
      <div className="p-4 md:p-8">
        {tab === RevenueDigitalPracticeTabs.settings ? (
          <PaymentSettings />
        ) : null}
        {tab === RevenueDigitalPracticeTabs.sessions ? <DPSessions /> : null}
        {tab === RevenueDigitalPracticeTabs.receipts ? <Receipts /> : null}
      </div>
    </>
  );
}
